import { useState } from 'react';
import { Box, Typography, TextField, Select, MenuItem, Button, Paper } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { STATUS_OPTIONS } from './CriterionItem';

interface AddCriterionFormProps {
  onAdd: (description: string, status: string) => void;
}

const AddCriterionForm: React.FC<AddCriterionFormProps> = ({ onAdd }) => {
  const [showForm, setShowForm] = useState(false);
  const [description, setDescription] = useState('');
  const [status, setStatus] = useState('GAP');

  const handleAdd = () => {
    if (!description.trim()) return;
    onAdd(description.trim(), status);
    setDescription('');
    setStatus('GAP');
    setShowForm(false);
  };

  if (!showForm) {
    return (
      <Button size="small" startIcon={<AddIcon />} onClick={() => setShowForm(true)} sx={{ mt: 1, alignSelf: 'flex-start' }}>
        Add Criterion
      </Button>
    );
  }

  return (
    <Paper variant="outlined" sx={{ p: 2, mt: 1 }}>
      <Typography variant="caption" sx={{ fontWeight: 600, mb: 1, display: 'block' }}>Add Manual Criterion</Typography>
      <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-start' }}>
        <TextField
          size="small"
          fullWidth
          placeholder="Criterion description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') handleAdd(); }}
        />
        <Select size="small" value={status} onChange={(e) => setStatus(e.target.value)} sx={{ minWidth: 150 }}>
          {STATUS_OPTIONS.map((opt) => (
            <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
          ))}
        </Select>
        <Button variant="contained" size="small" onClick={handleAdd} disabled={!description.trim()}>Add</Button>
        <Button size="small" onClick={() => { setShowForm(false); setDescription(''); }}>Cancel</Button>
      </Box>
    </Paper>
  );
};

export default AddCriterionForm;
